module.exports = __webpack_public_path__ + "static/media/arrow-blue-clarnium.f7d839c6.svg";